import React from 'react';
import {Box} from '~/native-ui/native-base';
import {useThemeProps} from 'native-base';
import getIndexedChildren from './getIndexedChildren';
import { AccordionContext } from './Context';

const Accordion = (
  {
    children,
    index: pIndex,
    defaultIndex,
    allowMultiple,
    allowToggle,
    onChange,
    shouldOpen,
    ...props
  },
  ref
) => {
  const {
    endingHeight,
    startingHeight,
    duration,
    isOpen,
    onAnimationEnd,
    onAnimationStart,
    ...newProps
  } = useThemeProps('Accordion', props);

  const [index, setIndex] = React.useState(pIndex || defaultIndex || []);
  //TODO: refactor for responsive prop
  // if (useHasResponsiveProps(props)) {
  //   return null;
  // }

  const isControlled = React.useRef(!!onChange && !!pIndex).current;

  React.useEffect(() => {
    if (!isControlled) { return; }
    setIndex(pIndex);
  }, [ isControlled, pIndex, setIndex ]);

  const changeHandler = (isOpening, activeIndex) => {
    let indexCopy = index.map((i) => i);
    const updateIndex = isControlled ? onChange : setIndex;
    if (isOpening) {
      allowMultiple ? indexCopy.push(activeIndex) : (indexCopy = [activeIndex])
      updateIndex(indexCopy)
    }
    else if (allowToggle) {
      const localCopy = index.map((i) => i);
      localCopy.splice(index.indexOf(activeIndex), 1);
      updateIndex(localCopy);
    } else {
        indexCopy = indexCopy.filter((n) => n !== activeIndex);
        updateIndex(indexCopy);
    }
  };
  return (
    <AccordionContext.Provider
      value={{
        shouldOpen,
        index: index,
        changeHandler,
        AnimationProps: {
          endingHeight,
          startingHeight,
          duration,
          isOpen,
          onAnimationEnd,
          onAnimationStart,
        },
      }}
    >
      <Box overflow="hidden" {...newProps} ref={ref}>
        {getIndexedChildren(children)}
      </Box>
    </AccordionContext.Provider>
  );
};

export default React.memo(React.forwardRef(Accordion));
